<template>
  <v-container fluid>
    <ActionBar />

    <div
      :class="[`${
        isFailed || !items.length
          ? 'page__content--no-items'
          : 'page__content'
      }`, {
        'page__content--from-v4': noMainMenuFromV4
      }]"
    >
      <Filters
        :status="currentStatus"
        @change="updateFilters"
      />

      <Table
        :items="itemsGroupByDate"
        :pagination="pagination"
        :status="currentStatus"
        @reloadData="reloadData"
        @goToPage="updatePage"
      />
    </div>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { isArray, removeDuplicateItemsInArray } from 'utils/functions'
import ActionBar from 'components/revenues/ActionBar'
import Filters from 'components/revenues/Filters'
import Table from 'components/revenues/Table'

export default {
  name: 'RevenuesPage',
  components: {
    ActionBar,
    Filters,
    Table
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen,
      selectedCompany: ({ company }) => company.selectedCompany,
      claims: ({ userClaims }) => userClaims.claims,
      noMainMenuFromV4: ({ mainMenu }) => mainMenu.noMainMenuFromV4
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Views.RevenuesPage',
      filters: {
        startDate: null,
        endDate: null
      },
      pagination: {
        totalElements: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 25
      },
      currentStatus: null,
      items: [],
      itemsGroupByDate: []
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidArray (val) {
      return isArray(val)
    },

    updatePagination (response, itemsPerPage) {
      this.pagination = {
        ...this.pagination,
        totalElements: response.totalElements,
        totalPages: response.totalPages
      }
    },

    resetPagination () {
      this.pagination = {
        totalElements: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 25
      }
    },

    updatePage (page) {
      scrollTo(0, 0)

      this.pagination = {
        ...this.pagination,
        currentPage: page
      }

      this.loadData()
    },

    formatDate (date) {
      return `${moment(date).format('DD/MM/YYYY')} ${moment(date).locale('pt-br').format('dddd')}`
    },

    dayGroup (data) {
      const rides = data.map(item => this.formatDate(item.date))
      return removeDuplicateItemsInArray(rides)
    },

    currentMonth () {
      const today = new Date()
      const day = String(today.getDate()).padStart(2, '0')
      const daysInMonth = moment().daysInMonth()
      const days = Number(day) < daysInMonth ? day : daysInMonth

      return {
        startDate: moment().format('YYYY-MM-') + '01T00:00:00',
        endDate: moment().format('YYYY-MM-') + days + 'T23:59:59'
      }
    },

    updateFilters ({ startDate, endDate }) {
      let startDateFormated = this.currentMonth().startDate
      let endDateFormated = this.currentMonth().endDate

      if (startDate) {
        startDateFormated = startDate && startDate.length === 10
          ? `${startDate}T00:00:00`
          : startDate.replace(/T\d{2}:\d{2}/, 'T00:00:00')
      }

      if (endDate) {
        endDateFormated = endDate && endDate.length === 10
          ? `${endDate}T23:59:59`
          : endDate.replace(/T\d{2}:\d{2}/, 'T23:59:59')
      }

      this.filters = {
        startDate: startDateFormated,
        endDate: endDateFormated
      }

      this.resetPagination()
      this.loadData()
    },

    async loadData () {
      if (this.currentStatus === STATUS_IS_LOADING) return

      this.currentStatus = STATUS_IS_LOADING

      try {
        const { currentPage, itemsPerPage } = this.pagination
        const { startDate, endDate } = this.filters
        const { data: res } = await this.$apiService.getFinancialSummary(
          { limit: itemsPerPage },
          { size: currentPage - 1 },
          { startDate },
          { endDate }
        )

        if (!res.valid) {
          const error = this.isValidArray(res.reasons) ? res.reasons[0] : res.message
          throw new Error(error)
        }

        this.items = res.content || []

        if (this.isValidArray(this.items)) {
          this.itemsGroupByDate = this.dayGroup(this.items).map(date => ({
            date,
            list: this.items.filter(item => this.formatDate(item.date) === date)
          }))
        }
        this.updatePagination(res, itemsPerPage)
        this.currentStatus = STATUS_SUCCESS
      } catch (err) {
        console.log('ERROR:', err)
        this.currentStatus = STATUS_FAILED
      }
    },

    reloadData () {
      this.resetPagination()
      this.loadData()
    }
  },

  watch: {
    selectedCompany () {
      this.reloadData()
    }
  },

  mounted () {
    this.loadData()
  }
}
</script>
